import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Accordion } from "@legacy/@bit/gedesco.reactcomponentsgdc.accordion"
import { AccordionTab } from "@legacy/@bit/gedesco.reactcomponentsgdc.accordion/dist/Accordion"
import { ImpuestoInsertFacturaOcrCommandProps } from "api/Commands/ImpuestoInsertFacturaOcrCommand"
import { RetencionInsertFacturaOcrCommandProps } from "api/Commands/RetencionInsertFacturaOcrCommandProps"
import { ConceptoGetDocumentoComercialImportadoByIdDtoProps } from "api/DTOs/ConceptoGetDocumentoComercialImportadoByIdDto"
import { GetDocumentoComercialImportadoByIdDtoProps } from "api/DTOs/GetDocumentoComercialImportadoByIdDto"
import CustomButton from "common/components/Button/Button"
import { DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import * as Validations from "common/utils/formValidations"
import notification from "common/utils/notification"
import { COLOR_PRIMARY } from "common/utils/theme"
import { DEFAULT_CURRENCY_ABREVIATURE } from "features/Contactos/constants/index"
import { ModalOcrUnverifiedProvider } from "features/OCR/components/ModalOcrUnverifiedProvider"
import { useOcrTaxes } from "features/OCR/hooks/useOcrTaxes"
import { ErrorMessage, withFormik } from "formik"
import { TFunction } from "i18next"
import moment from "moment"
import { Button } from "primereact/button"
import { Message } from "primereact/message"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { precisionNumber } from "utils/precisionNumber"
import * as Yup from "yup"
import { InternalOptions } from "yup/lib/types"
import { OCR_DATE_FORMATS, TAB } from "../../constants"
import { changeBetweenClienteProveedor } from "../../utils"
import { mapFacturaPendienteToFacturaPost } from "../../utils/mappers"
import DatosClienteForm from "../DatosClienteForm"
import DatosEmisorForm from "../DatosEmisorForm"
import DatosFacturaForm from "../DatosFacturaForm"
import ImporteForm from "../ImporteForm"

const MainForm = ({ loading, ...props }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const history = useHistory()
  const [showModal, setShowModal] = useState(false)

  const { impuestos, isClient, isProvider, empresaCreacion } = useOcrTaxes({
    ...props,
  })

  const handleSubmit = () => {
    if (
      !empresaCreacion()?.verificada &&
      ((isProvider && !isClient) || (isClient && !impuestos?.length)) &&
      !props.errors.libradoNif &&
      !props.errors.libradorNif &&
      props.values.libradorNif
    ) {
      setShowModal(true)
    } else if (!isProvider && !isClient) {
      notification.errorServidor({
        body: `${t("notification.mustBeProperties")}`,
      })
    } else if (Object.keys(props.errors)?.length) {
      notification.errorServidor({
        body: `${t("ocr.errorMsgForm")}`,
      })
    }

    props.handleSubmit()
  }

  const tabs = [
    {
      id: TAB.FACTURA_TAB,
      title: `${t("others.dataInvoice")}`,
      Component: DatosFacturaForm,
    },
    {
      id: TAB.PROVEEDOR_TAB,
      title: `${t("others.supplier")}`,
      Component: DatosEmisorForm,
    },
    {
      id: TAB.CLIENTE_TAB,
      title: `${t("others.client")}`,
      Component: DatosClienteForm,
    },
    {
      id: TAB.IMPORTE_TAB,
      title: `${t("others.import")}`,
      Component: ImporteForm,
    },
  ]

  const handleChangeBetweenClienteProveedor = (e: $TSMigrationFixMe) => {
    e.stopPropagation()
    changeBetweenClienteProveedor({
      values: props.values,
      setFieldValue: props.setFieldValue,
    })

    // IMPUESTOS
    const impuestosList = props.listaImpuestos?.filter(
      (impuesto: $TSMigrationFixMe) =>
        props.values?.empresaCreacion?.is === "librador"
          ? impuesto.tipo === "Venta"
          : impuesto.tipo === "Compra"
    )
    props.setFieldValue("listaImpuestos", impuestosList)
    props.values.impuestos?.map(
      (impuesto: $TSMigrationFixMe, index: $TSMigrationFixMe) => {
        const impuestoNuevo = impuestosList?.find(
          ({ value: { valor } }: $TSMigrationFixMe) =>
            valor === impuesto.porcentaje.valor
        )?.value
        return props.setFieldValue(
          `impuestos[${index}].porcentaje`,
          impuestoNuevo ?? {
            id: null,
            valor: impuesto.porcentaje.valor,
          }
        )
      }
    )

    // RETENCIONES
    const retencionesList = props.listaRetenciones?.filter(
      (retencion: $TSMigrationFixMe) =>
        props.values?.empresaCreacion?.is === "librador"
          ? retencion.tipo === "Venta"
          : retencion.tipo === "Compra"
    )
    props.setFieldValue("listaRetenciones", retencionesList)
    props.values.retencion?.map(
      (retencion: $TSMigrationFixMe, index: $TSMigrationFixMe) => {
        const retencionNueva = retencionesList?.find(
          ({ value: { valor } }: $TSMigrationFixMe) =>
            valor === retencion.porcentaje.valor
        )?.value
        return props.setFieldValue(
          `retencion[${index}].porcentaje`,
          retencionNueva ?? {
            id: null,
            valor: retencion.porcentaje.valor,
          }
        )
      }
    )
  }

  return (
    <>
      <ModalOcrUnverifiedProvider
        isOpen={showModal}
        close={() => setShowModal(false)}
        firstParagraphValues={{
          tipoFactura:
            props.values?.empresaCreacion?.is === "librador"
              ? "venta"
              : "compra",
        }}
      />
      <form onSubmit={props.handleSubmit}>
        <div className='d-flex justify-content-between align-items-center'>
          <Button
            style={{ width: "40px", height: "40px", color: COLOR_PRIMARY }}
            className='p-button-raised p-button-text'
            icon='pi pi-arrow-left'
            type='button'
            onClick={(e) => {
              e.preventDefault()
              history.push(ROUTES.IMPORTAR_FACTURAS_OCR)
            }}
          />

          <Message
            className='w-75'
            severity='info'
            // @ts-expect-error TS(2769): No overload matches this call.
            text={t("ocr.revisionInvocesMsg")}
          />

          <CustomButton
            className='!tw-bg-primary'
            loading={loading}
            onClick={handleSubmit}
          >
            {t("ocr.importButton")}
          </CustomButton>
        </div>

        <div
          style={{ maxHeight: "95vh" }}
          className='mt-3 overflow-auto remove-scroll row form-factura-container'
        >
          <div className='col-12'>
            {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
            <Accordion onChangeExpanded={() => {}}>
              {tabs?.map(({ id, title, Component }) => {
                let titleToShow = title

                if (id === TAB.CLIENTE_TAB || id === TAB.PROVEEDOR_TAB) {
                  // @ts-expect-error TS(2322): Type 'Element' is not assignable to type 'string'.
                  titleToShow = (
                    <div
                      className='d-flex align-items-center justify-content-between'
                      key={title}
                    >
                      {title}

                      <CustomButton
                        className='text'
                        onClick={handleChangeBetweenClienteProveedor}
                      >
                        <span
                          className='d-flex align-items-center'
                          style={{ gap: 1 }}
                        >
                          <FontAwesomeIcon icon={["fal", "arrows-repeat"]} />

                          <span className='ml-1'>
                            {t("ocr.changeLabel")}
                            {id === TAB.CLIENTE_TAB
                              ? ` ${t("newDoc.presupuesto.supplierLabel")}`
                              : ` ${t("newDoc.presupuesto.clientLabel")}`}
                          </span>
                        </span>
                      </CustomButton>
                    </div>
                  )
                }
                if (id === TAB.IMPORTE_TAB) {
                  // @ts-expect-error TS(2322): Type 'Element' is not assignable to type 'string'.
                  titleToShow = (
                    <span
                      className={
                        props.errors?.total &&
                        props.touched?.total &&
                        "!tw-text-danger"
                      }
                    >
                      {title}
                    </span>
                  )
                }

                return (
                  <>
                    <AccordionTab
                      defaultExpanded
                      key={id}
                      id={id}
                      title={titleToShow}
                      className={
                        props.errors.total &&
                        props.touched.total &&
                        id === TAB.IMPORTE_TAB
                          ? "tw-border tw-border-danger tw-border-solid"
                          : ""
                      }
                    >
                      <Component {...props} />
                    </AccordionTab>
                    {props.errors.total &&
                      props.touched.total &&
                      id === TAB.IMPORTE_TAB && (
                        <ErrorMessage
                          name='total'
                          component='div'
                          className='tw-text-danger tw-text-left'
                        />
                      )}
                  </>
                )
              })}
            </Accordion>
          </div>
        </div>
      </form>
    </>
  )
}

const validateForm = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    libradoRazonSocial: Validations.validateRazonSocial(t),
    libradoNif: Yup.string()
      .nullable()
      .when("libradoPais", {
        is: DEFAULT_COUNTRY_SELECTED,
        then: Validations.validateNif(t).notOneOf(
          [Yup.ref("libradorNif")],
          t("errors.nifsNotMatchMsg")
        ),
      }),
    libradorRazonSocial: Validations.validateRazonSocial(t),
    libradorNif: Yup.string()
      .nullable()
      .when("libradorPais", {
        is: DEFAULT_COUNTRY_SELECTED,
        then: Validations.validateNif(t).notOneOf(
          [Yup.ref("libradoNif")],
          t("errors.nifsNotMatchMsg")
        ),
      }),
    numero: Yup.string().required(t("errors.numFacturaEmpty")),
    fechaFactura: Yup.string().required(t("errors.dateEmpty")),
    total: Yup.number()
      .typeError(t("errors.importRequired"))
      .nullable()
      .required(t("errors.importRequired")),
    impuestos: Yup.array().of(
      Yup.object().shape({
        baseImponible: Yup.number()
          .nullable()
          .required(t("errors.importRequired")),
        porcentaje: Yup.object().shape({
          id: Yup.string()
            .nullable()
            .matches(
              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/,
              t("errors.percentInvalid")
            )
            .required(t("errors.percentRequired")),
          valor: Yup.number(),
        }),
        total: Yup.number().nullable().required(t("errors.importRequired")),
      })
    ),
    retencion: Yup.array().of(
      Yup.object().shape({
        baseImponible: Yup.number()
          .nullable()
          .test(
            "baseImponible",
            t("errors.importRequired"),
            (value, context) => {
              const valid = Boolean(
                (context.parent.porcentaje.id || context.parent.total) && !value
              )
              return !valid
            }
          )
          .required(t("errors.importRequired")),
        porcentaje: Yup.object()
          .nullable()
          .shape({
            id: Yup.string()
              .nullable()
              .matches(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/,
                t("errors.percentInvalid")
              )
              .test(
                "porcentaje",
                t("errors.percentRequired"),
                (value, context: InternalOptions) => {
                  const valid = Boolean(
                    context?.from &&
                      context.from.length > 1 &&
                      (context.from[1]?.value?.baseImponible ||
                        context.from[1]?.value?.total) &&
                      !value
                  )
                  return !valid
                }
              )
              .required(t("errors.percentRequired")),
            valor: Yup.number().nullable().required(t("errors.importRequired")),
          }),
        total: Yup.number()
          .nullable()
          .test(
            "totalRetencion",
            t("errors.importRequired"),
            (value, context) => {
              const valid = Boolean(
                (context.parent.baseImponible ||
                  context.parent.porcentaje.id) &&
                  !value
              )
              return !valid
            }
          ),
      })
    ),
  })

const validateTotals = (
  t: TFunction,
  {
    impuestos,
    retencion,
    total,
  }: {
    impuestos: ImpuestoInsertFacturaOcrCommandProps[]
    retencion: RetencionInsertFacturaOcrCommandProps[]
    total: number
  }
) => {
  const errors: {
    total?: string
  } = {}

  const impuestosBaseImponible = precisionNumber(
    impuestos.reduce(
      (
        acc: number,
        {
          baseImponible,
          total,
        }: {
          baseImponible: ImpuestoInsertFacturaOcrCommandProps["baseImponible"]
          total: ImpuestoInsertFacturaOcrCommandProps["total"]
        }
      ) => acc + baseImponible + total,
      0
    )
  )
  const retencionesTotal = precisionNumber(
    retencion.reduce(
      (
        acc: number,
        { total }: { total: RetencionInsertFacturaOcrCommandProps["total"] }
      ) => acc + total,
      0
    )
  )
  const retencionesBaseImponible = precisionNumber(
    retencion.reduce(
      (
        acc: number,
        {
          baseImponible,
        }: {
          baseImponible: RetencionInsertFacturaOcrCommandProps["baseImponible"]
        }
      ) => {
        return acc + baseImponible
      },
      0
    )
  )

  const tolerance = 0.01

  if (
    total >
      precisionNumber(impuestosBaseImponible - retencionesTotal + tolerance) ||
    total <
      precisionNumber(impuestosBaseImponible - retencionesTotal - tolerance)
  ) {
    errors.total = `${t("errors.invalidTaxRetention")}`
  }

  if (
    total > 0
      ? retencionesBaseImponible > impuestosBaseImponible
      : retencionesBaseImponible < impuestosBaseImponible
  ) {
    errors.total = `${t("errors.invalidTaxRetention")}`
  }

  return errors
}

const MainFormWithFormik = withFormik({
  // @ts-expect-error TS(2339): Property 't' does not exist on type '{}'.
  validate: (rowData, { t }) => validateTotals(t, rowData),
  mapPropsToValues: ({
    factura,
  }: {
    factura: GetDocumentoComercialImportadoByIdDtoProps
  }) => {
    const isValidTime = moment(
      factura?.fechaEmision,
      OCR_DATE_FORMATS
    ).isValid()
    const dateEmision = moment(factura?.fechaEmision, OCR_DATE_FORMATS).toDate()
    return {
      id: factura?.id,
      divisa: DEFAULT_CURRENCY_ABREVIATURE,
      numero: factura?.numero,
      fechaFactura: isValidTime ? dateEmision : "",

      libradorNif: factura?.proveedor?.nif,
      libradorRazonSocial: factura?.proveedor?.razonSocial,
      // TODO: reemplazar. Igual a libradorRazonSocial
      libradorID: factura?.proveedor?.razonSocial,
      libradorPais: DEFAULT_COUNTRY_SELECTED,

      libradoNif: factura?.cliente?.nif,
      libradoRazonSocial: factura?.cliente?.razonSocial,
      // TODO: reemplazar. Igual a libradoRazonSocial
      libradoID: factura?.cliente?.razonSocial,
      libradoPais: DEFAULT_COUNTRY_SELECTED,

      totalRetencion: factura?.retencion?.total,
      total: factura?.importe ? factura.importe : undefined,
      empresaCreacionId: undefined,
      empresaCreacion: undefined,

      impuestos: factura?.conceptos?.length
        ? factura.conceptos?.map(
            (concepto: ConceptoGetDocumentoComercialImportadoByIdDtoProps) => ({
              baseImponible:
                (concepto?.baseImponible !== 0 && concepto?.baseImponible) ??
                factura?.baseImponible,
              porcentaje: {
                id: undefined,
                valor: concepto.porcentaje,
              },
              total: concepto.importe,
            })
          )
        : [
            {
              baseImponible: factura?.baseImponible,
              porcentaje: { id: null, valor: null },
              total: undefined,
            },
          ],
      listaImpuestos: [],
      retencion:
        factura?.retencion !== null
          ? [
              {
                baseImponible:
                  factura?.importe && factura?.descuento?.total
                    ? factura?.importe - factura?.descuento?.total
                    : undefined,
                porcentaje: {
                  id: undefined,
                  valor: factura?.retencion?.porcentaje,
                },
                total: factura?.retencion?.total,
              },
            ]
          : [],
      listaRetenciones: [],
    }
  },
  validationSchema: ({ t }: $TSMigrationFixMe) => {
    return validateForm(t)
  },
  handleSubmit: (values, { props }) => {
    const postData = mapFacturaPendienteToFacturaPost({
      values,
    })
    // @ts-expect-error TS(2339): Property 'postFacturaOCR' does not exist on type '...
    props.postFacturaOCR(postData)
  },
})(MainForm)

export default MainFormWithFormik
